import { TbPasswordFingerprint } from "react-icons/tb";
import PasswordStrengthIndicator from "../../common/PasswordStrengthIndicator";

const PasswordStep = ({
  newPassword,
  confirmPassword,
  setNewPassword,
  setConfirmPassword,
  isLoading,
  onSubmit,
  onBack,
}: PasswordStepProps) => {
  return (
    <form onSubmit={onSubmit} className="w-full space-y-4">
      <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
        <TbPasswordFingerprint className="text-2xl text-center text-white" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-center text-gray-7">
          Create New Password
        </h1>
        <p className="text-gray-6 text-center">
          Please enter and confirm your new password.
        </p>
      </div>
      <div className="space-y-4">
        <div className="space-y-2">
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="New password"
            required
            className="w-full px-4 py-2 border border-gray-3 rounded-lg focus:ring-1 focus:ring-gray-5 focus:border-gray-5 outline-none"
          />
          <PasswordStrengthIndicator password={newPassword} />
        </div>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          required
          className="w-full px-4 py-2 mb-8 border border-gray-3 rounded-lg focus:ring-1 focus:ring-gray-5 focus:border-gray-5 outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className="w-full px-4 py-2 text-white bg-gray-7 rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Updating..." : "Update Password"}
      </button>
      <button
        type="button"
        onClick={onBack}
        className="w-full px-4 py-2 text-black rounded-lg border border-gray-7 hover:bg-gray-2 hover:text-white focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
      >
        Back
      </button>
    </form>
  );
};

export default PasswordStep;

interface PasswordStepProps {
  newPassword: string;
  confirmPassword: string;
  setNewPassword: (password: string) => void;
  setConfirmPassword: (password: string) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onBack: () => void;
}
